import '../css/app.css'
import '../css/main.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
    LayoutDashboard, NotebookPen, Volume2, PhoneCall, CreditCard, FilePenLine, ChevronDown
} from 'lucide-react';
import { useSelector } from 'react-redux';

function Sidebar() {
    let location = useLocation();
    let Current_Location = useSelector((state) => { return state.Current_Location.value });

    const [windowtypeM, setWindowtypeM] = useState(false)
    const [cur, setCur] = useState(-1)
    const [btn, setBtn] = useState([false, false, false])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1280) setWindowtypeM(true)
            else setWindowtypeM(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (Current_Location) {
            if (Current_Location == "대시보드") { setCur(5); onFirstBtn(-1) }
            else if (Current_Location == "수기결제") { setCur(0); onFirstBtn(-1) }
            else if (Current_Location == "거래조회") { setCur(1); onFirstBtn(-1) }
            else if (Current_Location == "공지사항") { setCur(2); onFirstBtn(-10) }
            else if (Current_Location == "정산내역") { setCur(3); onFirstBtn(-1) }
            else if (Current_Location == "입출금내역") { setCur(4); onFirstBtn(-1) }
            else if (Current_Location == "URL상품관리") { setCur(11); onFirstBtn(0) }
            else if (Current_Location == "URL상품결제내역") { setCur(12); onFirstBtn(0) }
            else if (Current_Location == "SMS수기결제") { setCur(13); onFirstBtn(-1) }
            else if (Current_Location == "SMS인증결제") { setCur(14); onFirstBtn(-1) }
        }
    }, [Current_Location])

    const onClickBtn = (e) => {
        let arr = [false, false, false]
        for (let i = 0; i < 3; i++) {
            if (e === i) {
                if (btn[i]) arr[i] = false
                else arr[i] = true
            }
            else arr[i] = btn[i]
        }
        setBtn(arr)
    }

    const onFirstBtn = (e) => {
        let arr = [false, false, false]
        for (let i = 0; i < 3; i++) {
            if (e === i) arr[i] = true
        }
        setBtn(arr)
    }

    return (
        <div className="flex overflow-hidden" style={{
            display: location.pathname == '/'
                || location.pathname == '/createMerchantsAgent'
                || location.pathname == '/urlPayment'
                || location.pathname == '/urlComplete'
                || location.pathname == '/smsPayment'
                || location.pathname == '/smsAuthPayment'
                || location.pathname == '/sms'
                || location.pathname == '/smsa'
                || location.pathname.startsWith('/urlPayment/sms')
                ? "none" : ""
        }}>
            <nav className="side-nav" style={{ backgroundColor: "#f1f5f9", minHeight: "100dvh", borderRight: "5px solid #fff" }}>
                <ul>
                    <li>
                        <Link to={`/dashboard`} className={`side-menu ${cur == 5 ? "side-menu--active" : ""}`} data-id="main">
                            <div className="side-menu__icon">
                                <LayoutDashboard />
                            </div>
                            <div className="side-menu__title">
                                <span>대시보드</span>
                            </div>
                        </Link>
                    </li>
                    {
                        JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                            ?
                            <li>
                                <Link to={`/sugi`} className={`side-menu ${cur == 0 ? "side-menu--active" : ""}`} data-id="main">
                                    <div className="side-menu__icon">
                                        <CreditCard />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>수기결제</span>
                                    </div>
                                </Link>
                            </li>
                            :
                            ""
                    }
                    <li>
                        <Link to={`/paylist`} className={`side-menu ${cur == 1 ? "side-menu--active" : ""}`} data-id="main">
                            <div className="side-menu__icon">
                                <NotebookPen />
                            </div>
                            <div className="side-menu__title">
                                <span>거래조회</span>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to={`/settlement`} className={`side-menu ${cur == 3 ? "side-menu--active" : ""}`} data-id="main">
                            <div className="side-menu__icon">
                                <FilePenLine />
                            </div>
                            <div className="side-menu__title">
                                <span>정산내역</span>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to={`/withdraw`} className={`side-menu ${cur == 4 ? "side-menu--active" : ""}`} data-id="main">
                            <div className="side-menu__icon">
                                <FilePenLine />
                            </div>
                            <div className="side-menu__title">
                                <span>입출금내역</span>
                            </div>
                        </Link>
                    </li>
                    {
                        JSON.parse(localStorage.getItem("userId"))?.urlpay == 1
                            ?
                            <li>
                                <Link to={`/urlCreate`} className={`side-menu ${cur == 11 || cur == 12 ? "side-menu--active" : ""}`} onClick={() => onClickBtn(0)} >
                                    <div className="side-menu__icon">
                                        <FilePenLine />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>URL결제</span>
                                        <div className="side-menu__sub-icon">
                                            <ChevronDown />
                                        </div>
                                    </div>
                                </Link>
                                {
                                    btn[0]
                                        ?
                                        <ul className="depth-2">
                                            <li>
                                                <Link to={`/urlCreate`} className={`side-menu ${cur == 11 ? "side-menu--active" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <FilePenLine />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>URL상품관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={`/urlHistory`} className={`side-menu ${cur == 12 ? "side-menu--active" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <FilePenLine />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>URL결제내역</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        </ul>
                                        :
                                        ""
                                }
                            </li>
                            :
                            ""
                    }
                    {
                        JSON.parse(localStorage.getItem("userId"))?.smsKYC == 1
                            ?
                            <li>
                                <Link to={`/smsPayment`} className={`side-menu ${cur == 13 ? "side-menu--active" : ""}`} data-id="main">
                                    <div className="side-menu__icon">
                                        <PhoneCall />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>SMS수기결제</span>
                                    </div>
                                </Link>
                            </li>
                            :
                            ""
                    }
                    {
                        JSON.parse(localStorage.getItem("userId"))?.smsConfirm == 1
                            ?
                            <li>
                                <Link to={`/smsAuthPayment`} className={`side-menu ${cur == 14 ? "side-menu--active" : ""}`} data-id="main">
                                    <div className="side-menu__icon">
                                        <PhoneCall />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>SMS인증결제</span>
                                    </div>
                                </Link>
                            </li>
                            :
                            ""
                    }


                    {/* <li>
                        <Link to={`/notice`} className={`side-menu ${cur == 2 ? "side-menu--active" : ""}`} data-id="main">
                            <div className="side-menu__icon">
                                <Volume2 />
                            </div>
                            <div className="side-menu__title">
                                <span>공지사항</span>
                            </div>
                        </Link>
                    </li> */}

                    {/* <div className="customer-info">
                        {
                            windowtypeM
                                ?
                                <>
                                    <div className="cust-text">CUSTOMER CENTER</div>
                                    <div className="cust-phone">
                                        <PhoneCall /><span>1600-4406</span>
                                    </div>
                                    <div className="cust-work"><span>평일</span>09:00 - 18:00</div>
                                    <div className="cust-rest"><span>휴무</span>토/일/공휴일 휴무</div>
                                </>
                                :
                                <PhoneCall />
                        }
                    </div> */}
                </ul>
            </nav>
        </div>
    )
}

export default Sidebar;